import { Injectable } from '@angular/core';
import { AlertController, IonicSafeString } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class AlertMessager {
    showingAlert: boolean;
    constructor(private alert: AlertController) { }

    async showError(header: string, message: string) {
        const error = await this.alert.create({
            header,
            message: new IonicSafeString(message).value,
            buttons: [
            {
                text: 'Dismiss',
                handler: () => {
                    // Do nothing
                }
            }]
        });

        this.showingAlert = true;
        await error.present();
        error.onWillDismiss().then(() => this.showingAlert = false);
    }

    async showConfirmation(header: string, message: string) {
        const error = await this.alert.create({
            header,
            message: new IonicSafeString(message).value,
            buttons: [
            {
                text: 'Ok',
                handler: () => {
                    // Do nothing
                }
            }]
        });
        await error.present();
    }

    async prompt(header: string, message: string, handler: () => any, noHandler: () => any) {
        const prompt = await this.alert.create({
            header,
            message: new IonicSafeString(message).value,
            buttons: [
            {
                text: 'Yes',
                handler: handler
            },
            {
                text: 'No',
                handler: noHandler
            }]
        });
        prompt.present();
    }
}
